<div class="row">
  <div class="columns small-12 medium-10">
    <h1 class="rs-tit1-sp">{{ pageTitle | translate }}</h1>
  </div>
</div>
<div class="row">
  <div class="columns small-12">
    <div class="rs-msgbox rs-warning" data-alert="" role="alert">
      <div class="rs-msgbox-title">
        {{ 'bills.expiredToken.title' | translate }}
      </div>
      <div class="rs-msgbox-content">
        <p>{{ 'bills.expiredToken.description' | translate }}</p>
        <a
          href="javascript:void(0)"
          (click)="goToLogin()"
          class="rs-btn rs-btn-third rs-btn-third-icon-left"
          ><i class="rs-icon-btn-third rs-margin-right1" aria-hidden="true"></i>
          {{ 'bills.expiredToken.buttonLabel' | translate }}
        </a>
      </div>
      <div class="rs-msgbox-icon">
        <i class="icon-Warning-box" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</div>
